/* Convenience deterrent only: public media URLs remain downloadable. */
(() => {
  'use strict';
  const key = Symbol.for('vonela.imageContextMenu');
  if (window[key]) return;
  window[key] = true;

  const loox = '[id*="loox" i], [class*="loox" i], [data-loox-id], [data-loox-widget]';
  const media = 'img, picture, video, canvas, svg image, input[type="image"]';
  const editable = 'textarea, input:not([type="image"]), select, [contenteditable]:not([contenteditable="false"])';
  const text = 'p, h1, h2, h3, h4, h5, h6, label, blockquote, figcaption';
  const isLoox = (element) => Boolean(element.closest(loox));
  const hasBackground = (element) => getComputedStyle(element).backgroundImage.includes('url(');

  document.addEventListener('contextmenu', (event) => {
    const path = event.composedPath();
    const target = path.find((node) => node instanceof Element);
    if (!target) return;
    // Leave native reviews, their dialogs/frames and all editing menus untouched.
    if (path.some((node) => node instanceof Element && isLoox(node))) return;
    if (target.closest(editable)) return;

    if (target.closest(media) || hasBackground(target)) {
      event.preventDefault();
      return;
    }
    const textBlock = target.closest(text);
    if (textBlock) {
      const rect = textBlock.getBoundingClientRect();
      // Stretched card-link pseudo-elements can reach outside their heading.
      if (event.clientX >= rect.left && event.clientX < rect.right &&
          event.clientY >= rect.top && event.clientY < rect.bottom) return;
    }

    // Catch transparent layers and play controls over media without disabling clicks.
    // Hit-testing, rather than a page-wide ban, preserves non-media context menus.
    const hits = document.elementsFromPoint(event.clientX, event.clientY);
    if (hits.some((element) => !isLoox(element) && (element.matches(media) || hasBackground(element)))) {
      event.preventDefault();
      return;
    }

    // Some theme images deliberately have pointer-events:none and are absent above.
    const surface = target.closest('figure, picture, [data-media-id], .vp-slide, .vvr-media, [class$="__media"]');
    if (!surface || isLoox(surface)) return;
    const covered = [...surface.querySelectorAll(media)].some((element) => {
      if (isLoox(element)) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && event.clientX >= rect.left &&
        event.clientX < rect.right && event.clientY >= rect.top && event.clientY < rect.bottom;
    });
    if (covered) event.preventDefault();
  }, { capture: true });
})();
